<style lang="scss" scoped>
@import './../../assets/style-colors.scss';

.h-nav {
  background-color: $blue;
}
</style>

<template>
  <div class="h-nav">
    <b-navbar class="py-1" style="z-index: 5" toggleable="md" type="dark">
      <b-navbar-toggle target="nav_collapse" />

      <b-navbar-brand style="line-height: 1">
        <img src="../../assets/images/siemens-logo-en-2x-white.png" style="height: 1.2rem" />
      </b-navbar-brand>

      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown v-if="!webkey" right style="visibility: hidden" text="Help" />

        <b-nav-item-dropdown v-else right :text="webkey.id">
          <b-dd-header>Account Center</b-dd-header>
          <b-dd-item :to="{name: 'profile', params: {}}"> My Profile </b-dd-item>

          <div v-show="admin">
            <b-dd-divider />
            <b-dd-header>Utilities</b-dd-header>
            <b-dd-item @click="showFtgModal"> Key Generator </b-dd-item>
            <b-dd-item @click="showSoldtoModal"> Tag Soldto </b-dd-item>
          </div>

          <b-dd-divider />
          <b-dd-header>Help</b-dd-header>
          <b-dd-item href="mailto:tac_mis.plm@siemens.com"> TAC MIS </b-dd-item>

          <b-dd-divider />
          <b-dd-item href="webkey_auth/logout.php5"> Logout </b-dd-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>

    <ftoggle />
    <soldto />
  </div>
</template>

<script>
import {mapState} from 'vuex'

import helper from '@/lib/helper'
import store from '@/store/store'
import ftoggle from '@/components/shared/ftoggle'
import soldto from '@/components/shared/soldto'

export default {
  components: {ftoggle, soldto},
  data() {
    return {
      admin: helper.admin(),
    }
  },
  computed: {
    ...mapState(['webkey']),
  },
  methods: {
    showFtgModal() {
      store.commit('ftoggle/show', true)
    },
    showSoldtoModal() {
      store.commit('soldto/show', true)
    },
  },
}
</script>
